import React, { useEffect, useState } from "react";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
// import { Data } from "react-csv/components/CommonPropTypes";
// import { GridColumns } from "@mui/x-data-grid";
import CSVDetalhesModalTopo from "./CSVDetalhesModalTopo";
import CSVDetalhesModalDetalhe from "./CSVDetalhesModalDetalhe";

export default function CSVDetalhesModal(props: CSVDetalhesModalPropsTypes) {
  return (
    <>
      <div
        className="containerForecastModal"
        style={{ width: "80vw", height: "90vh" }}
      >
        <div className="containerTitleModal">
          <CSVDetalhesModalTopo name={props.name} />
        </div>
        <div className="containerToolbarModal">
          <Tooltip title="Sair do Modal">
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          <CSVDetalhesModalDetalhe
            detalhes={props.detalhes}
            handleClose={props.handleClose}
            name={props.name}
          />
        </div>
      </div>
    </>
  );
}

interface CSVDetalhesModalPropsTypes {
  handleClose: any;
  detalhes: string;
  name: string;
}
